import produce from 'immer';
import formStylesSchema from 'helpers/formStylesSchema';
import {
  CHANGE_STYLE_PROPERTY,
  SET_CURRENT_SCHEMA_NAME,
  SAVE_STORE_STYLES_START,
  SAVE_STORE_STYLES_SUCCESS,
  SAVE_STORE_STYLES_FAILED,
  GET_CURRENT_STORE_STYLES_START,
  GET_CURRENT_STORE_STYLES_SUCCESS,
  GET_CURRENT_STORE_STYLES_FAILED,
  GET_DEFAULT_STORE_STYLES_START,
  GET_DEFAULT_STORE_STYLES_SUCCESS,
  GET_DEFAULT_STORE_STYLES_FAILED
} from '../actions/styles_palette';


const initialState = {
  stylePalette: {},
  currentStylePalette: {},
  defaultStylePalette: {},
  currentSchemaName: 'Current Schema',
  loadingCurrentStoreStyles: false,
  loadingDefaultStoreStyles: false,
  savingStylePalette: false
};


const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case CHANGE_STYLE_PROPERTY: {
      const {palette} = action;

      state.stylePalette = palette;
      break;
    }

    case SET_CURRENT_SCHEMA_NAME: {
      const {schemaName} = action;

      state.currentSchemaName = schemaName;
      break;
    }

    case SAVE_STORE_STYLES_START: {
      state.savingStylePalette = true;
      break;
    }

    case SAVE_STORE_STYLES_SUCCESS: {
      const {data, isSaveAsDefault} = action;
      state.currentStylePalette = formStylesSchema(data.config);
      state.stylePalette = state.currentStylePalette;

      if (isSaveAsDefault) {
        state.defaultStylePalette = state.currentStylePalette;
      }

      state.currentSchemaName = 'Current Schema',
      state.savingStylePalette = false;
      break;
    }

    case SAVE_STORE_STYLES_FAILED: {
      state.savingStylePalette = false;
      break;
    }

    case GET_CURRENT_STORE_STYLES_START: {
      state.loadingCurrentStoreStyles = true;
      break;
    }

    case GET_CURRENT_STORE_STYLES_SUCCESS: {
      const { data } = action;

      const stylePalette = formStylesSchema(data);

      state.currentStylePalette = stylePalette;

      if (!Object.keys(state.stylePalette).length) {
        state.stylePalette = stylePalette;
      }

      state.loadingCurrentStoreStyles = false;
      break;
    }

    case GET_CURRENT_STORE_STYLES_FAILED: {
      state.loadingCurrentStoreStyles = false;
      break;
    }


    case GET_DEFAULT_STORE_STYLES_START: {
      state.loadingDefaultStoreStyles = true;
      break;
    }

    case GET_DEFAULT_STORE_STYLES_SUCCESS: {
      const { data } = action;

      const stylePalette = formStylesSchema(data.configs);

      state.defaultStylePalette = stylePalette;
      state.loadingDefaultStoreStyles = false;
      break;
    }

    case GET_DEFAULT_STORE_STYLES_FAILED: {
      state.loadingDefaultStoreStyles = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
